import { Grid2, Chip as MUIChip, Show, styled, Typography } from "components";
import { useFormContext } from "react-hook-form";
import { handleCapitalize } from "utils/common";
import { htmlToText } from "utils/helpers";
import { handleRemoveUnderscore } from "utils/StringFunctions";

interface Props {
  benchmarkList: any;
}

const Chip = styled(MUIChip)(() => {
  return {
    borderRadius: 8,
    marginRight: 8,
    marginTop: 8,
    "& .MuiChip-label": { textTransform: "capitalize" },
  };
});

const CustomReportPreview = (props: Props) => {
  const form = useFormContext();

  const { benchmarkList } = props;

  return (
    <Show.When
      isTrue={form.getValues("selectedReported")?.reportType === "template"}
    >
      {form.getValues("selectedReported.customData") && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={12}>
            <Typography fontWeight={600} fontSize={22}>
              Report Preferences
            </Typography>
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.availableTimePeriods")
        ?.length !== 0 && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Available Time Periods</Typography>
          </Grid2>
          <Grid2 size={8}>
            {form
              .getValues("selectedReported.customData.availableTimePeriods")
              ?.map((dataItem: any) => {
                return (
                  <Chip
                    label={handleCapitalize(handleRemoveUnderscore(dataItem))}
                  />
                );
              })}
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.optionsToInclude")
        ?.length !== 0 && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Section to includes</Typography>
          </Grid2>
          <Grid2 size={8}>
            {form
              .getValues("selectedReported.customData.optionsToInclude")
              ?.map((dataItem: string) => {
                return (
                  <Chip
                    label={handleCapitalize(handleRemoveUnderscore(dataItem))}
                  />
                );
              })}
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.optionalField")?.length !==
        0 && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Optional Field</Typography>
          </Grid2>
          <Grid2 size={8}>
            {form
              .getValues("selectedReported.customData.optionalField")
              ?.map((dataItem: string) => {
                return (
                  <Chip
                    sx={{
                      "& .MuiChip-label": {
                        textTransform: ["stt", "twrr"].includes(dataItem)
                          ? "uppercase"
                          : "capitalize",
                      },
                    }}
                    label={handleCapitalize(handleRemoveUnderscore(dataItem))}
                  />
                );
              })}
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.benchmark")?.length !==
        0 && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Benchmark</Typography>
          </Grid2>
          <Grid2 size={8}>
            {benchmarkList
              ?.filter((option: { value: string }) =>
                form
                  .getValues("selectedReported.customData.benchmark")
                  ?.includes(option?.value),
              )
              ?.map((benchmark: { name: string }) => (
                <Chip label={benchmark?.name} />
              ))}
          </Grid2>
        </Grid2>
      )}

      <Show.When
        isTrue={
          form.getValues("selectedReported")?.reportName !==
          "benchmark_performance_report"
        }
      >
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Portfolio Calculation Preference</Typography>
          </Grid2>
          <Grid2 size={8}>
            <Chip
              label={
                form.getValues("selectedReported.customData.tradesPlusCash")
                  ? "Trades + Cash"
                  : "Trades"
              }
            />
          </Grid2>
        </Grid2>
      </Show.When>
      {form.getValues("selectedReported.customData.returnMetrics") && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Return Metrics</Typography>
          </Grid2>
          <Grid2 size={8}>
            <Chip
              label={form
                .getValues("selectedReported.customData.returnMetrics")
                ?.toUpperCase()}
            />
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.selectType") && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Select Type</Typography>
          </Grid2>
          <Grid2 size={8}>
            <Chip
              label={form
                .getValues("selectedReported.customData.selectType")
                ?.toUpperCase()}
            />
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.quote") && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Quote</Typography>
          </Grid2>
          <Grid2 size={8}>
            <Typography>
              {handleCapitalize(
                handleRemoveUnderscore(
                  form.getValues("selectedReported.customData.quote"),
                ),
              )}
            </Typography>
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.requestBody") && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Report Body</Typography>
          </Grid2>
          <Grid2 size={8} height={"auto"} overflow={"auto"} pr={1}>
            <Typography>
              {htmlToText(
                form.getValues("selectedReported.customData.requestBody"),
              )}
            </Typography>
          </Grid2>
        </Grid2>
      )}
      {form.getValues("selectedReported.customData.disclaimer") && (
        <Grid2 size={12} container alignItems={"baseline"}>
          <Grid2 size={4}>
            <Typography>Disclaimer</Typography>
          </Grid2>
          <Grid2 size={8} height={"auto"} overflow={"auto"} pr={1}>
            <Typography>
              {htmlToText(
                form.getValues("selectedReported.customData.disclaimer"),
              )}
            </Typography>
          </Grid2>
        </Grid2>
      )}
    </Show.When>
  );
};

export default CustomReportPreview;
